export default __webpack_public_path__ + "static/media/yzwechat.ecb9fbfc.jpg";